import { createContext } from "react";

/** A `{segment}/{id}[/{tab}]` overlay level parsed from the current URL. */
export interface RoutedOverlayChainLevel {
  segment: string;
  /** Path the level closes to */
  parentPath: string;
}

/** Overlay levels that a route-aware provider parsed from the current URL. */
export interface RoutedOverlayChain {
  /** Page path before the first level */
  basePath: string;
  levels: readonly RoutedOverlayChainLevel[];
  /** The last level with its tab, or `basePath` */
  tipPath: string;
  /** Leading page path, such as a site prefix, that no level or overlay segment starts in */
  pathPrefix?: string;
}

/**
 * Set by `DrawerStackProvider` with `routes`, so global overlays can tell a registered
 * drawer's id apart from their own segment.
 */
export const RoutedOverlayChainContext = createContext<
  RoutedOverlayChain | undefined
>(undefined);
